/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetLivestockKpiSummaryQueryResponse, GetLivestockKpiSummaryPathParams, GetLivestockKpiSummaryQueryParams, GetLivestockKpiSummary400, GetLivestockKpiSummary401, GetLivestockKpiSummary403, GetLivestockKpiSummary404, GetLivestockKpiSummary409, GetLivestockKpiSummary500 } from "../../types/analyticsController/GetLivestockKpiSummary.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getLivestockKpiSummary } from "../../client/analyticsController/getLivestockKpiSummary.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLivestockKpiSummaryQueryKey = (organizationId: GetLivestockKpiSummaryPathParams["organizationId"] | undefined, params?: GetLivestockKpiSummaryQueryParams) => [{ url: '/api/organizations/:organizationId/analytics/livestock-kpi-summary', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type GetLivestockKpiSummaryQueryKey = ReturnType<typeof getLivestockKpiSummaryQueryKey>

export function getLivestockKpiSummaryQueryOptions(organizationId: GetLivestockKpiSummaryPathParams["organizationId"] | undefined, params?: GetLivestockKpiSummaryQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLivestockKpiSummaryQueryKey(organizationId, params)
        return queryOptions<GetLivestockKpiSummaryQueryResponse, ResponseErrorConfig<GetLivestockKpiSummary400 | GetLivestockKpiSummary401 | GetLivestockKpiSummary403 | GetLivestockKpiSummary404 | GetLivestockKpiSummary409 | GetLivestockKpiSummary500>, GetLivestockKpiSummaryQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLivestockKpiSummary(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Livestock KPI summary — growth, stocking, reproduction and mortality — for the organization (optionally one farm via ?establishmentId, optionally a subset via ?sections=)
 * {@link /api/organizations/:organizationId/analytics/livestock-kpi-summary}
 */
export function useGetLivestockKpiSummary<TData = GetLivestockKpiSummaryQueryResponse, TQueryData = GetLivestockKpiSummaryQueryResponse, TQueryKey extends QueryKey = GetLivestockKpiSummaryQueryKey>(organizationId: GetLivestockKpiSummaryPathParams["organizationId"] | undefined, params?: GetLivestockKpiSummaryQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetLivestockKpiSummaryQueryResponse, ResponseErrorConfig<GetLivestockKpiSummary400 | GetLivestockKpiSummary401 | GetLivestockKpiSummary403 | GetLivestockKpiSummary404 | GetLivestockKpiSummary409 | GetLivestockKpiSummary500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLivestockKpiSummaryQueryKey(organizationId, params)
         

         const query = useQuery({
          ...getLivestockKpiSummaryQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLivestockKpiSummary400 | GetLivestockKpiSummary401 | GetLivestockKpiSummary403 | GetLivestockKpiSummary404 | GetLivestockKpiSummary409 | GetLivestockKpiSummary500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}